var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.comp,on:{"click":function($event){return _vm.$emit('click')}}},[_c('icon-close',{attrs:{"fill":"#231134"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }